import React, { useState } from "react";
import { FaRegAddressCard, FaBuilding, FaUsers, FaChartLine, FaChevronLeft, FaChevronRight, FaQuoteLeft, FaStar } from "react-icons/fa";
import "./Reviewcard.css";

const steps = [
  { title: "Sign Up", description: "Create your account in minutes.", icon: FaRegAddressCard },
  { title: "Add Your Companies", description: "Set up multiple firms and locations.", icon: FaBuilding },
  { title: "Manage Your Workforce", description: "Add employees, set policies and go live.", icon: FaUsers },
  { title: "Track, Automate & Grow", description: "Save time and focus on what matters.", icon: FaChartLine },
];

const reviews = [
  { name: "Aman", quote: "It's easy to use, speeds up payroll, tracks taxes and follows all the rules. The reports and tools help us manage work and time off. The support team is super helpful." },
  { name: "Divya", quote: "The reports are easy to understand and help us manage our workforce effectively. Plus, it syncs seamlessly with our finances. The support team is friendly and quick to respond." },
  { name: "Aditya", quote: "It's user-friendly and speeds up our payroll process significantly. The reports are clear and easy to interpret. Integration with our financial tools is seamless, making our operations smoother." },
];

const ReviewCard = () => {
  const [index, setIndex] = useState(0);
  const navigate = (direction) => setIndex((current) => (current + direction + reviews.length) % reviews.length);

  return (
    <div className="billpunch-stories">
      <section className="billpunch-steps" aria-labelledby="billpunch-steps-title">
        <h2 id="billpunch-steps-title">How BillPunch Works</h2>
        <p className="billpunch-steps__subtitle">Get started in a few simple steps and transform the way you manage HR.</p>
        <ol className="billpunch-steps__list">
          {steps.map(({ title, description, icon: Icon }, stepIndex) => (
            <li key={title} className="billpunch-steps__item">
              <span className="billpunch-steps__number">{String(stepIndex + 1).padStart(2, "0")}</span>
              <div className="billpunch-steps__content">
                <span className="billpunch-steps__icon"><Icon aria-hidden="true" /></span>
                <h3>{title}</h3>
                <p>{description}</p>
              </div>
              {stepIndex < steps.length - 1 && <FaChevronRight className="billpunch-steps__arrow" aria-hidden="true" />}
            </li>
          ))}
        </ol>
      </section>
      <section className="billpunch-testimonials" aria-labelledby="billpunch-testimonials-title">
        <div className="billpunch-testimonials__inner">
          <div className="billpunch-testimonials__heading">
            <div><span className="billpunch-testimonials__label">Customer Stories</span><h2 id="billpunch-testimonials-title">Loved by HR Teams and Business Leaders</h2></div>
            <div className="billpunch-testimonials__controls">
              <button type="button" onClick={() => navigate(-1)} aria-label="Previous customer story"><FaChevronLeft aria-hidden="true" /></button>
              <button type="button" onClick={() => navigate(1)} aria-label="Next customer story"><FaChevronRight aria-hidden="true" /></button>
            </div>
          </div>
          <div className="billpunch-testimonials__cards" aria-live="polite" aria-atomic="true">
            {reviews.map((_, offset) => {
              const review = reviews[(index + offset) % reviews.length];
              return (
                <article key={review.name} className="billpunch-testimonial">
                  <FaQuoteLeft className="billpunch-testimonial__quote-icon" aria-hidden="true" />
                  <div className="billpunch-testimonial__body">
                    <blockquote>{review.quote}</blockquote>
                    <div className="billpunch-testimonial__stars" role="img" aria-label="5 out of 5 stars">{Array.from({ length: 5 }, (_, star) => <FaStar key={star} aria-hidden="true" />)}</div>
                  </div>
                  <div className="billpunch-testimonial__author">
                    <span className="billpunch-testimonial__avatar" aria-hidden="true">{review.name.charAt(0)}</span>
                    <div><h3>{review.name}</h3><p>HR Head</p></div>
                    <span className="billpunch-testimonial__industry">IT &amp; SaaS</span>
                  </div>
                </article>
              );
            })}
          </div>
          <div className="billpunch-testimonials__dots">{reviews.map((review, dot) => <button key={review.name} type="button" aria-label={`Show ${review.name}'s story`} aria-pressed={index === dot} onClick={() => setIndex(dot)} />)}</div>
        </div>
      </section>
    </div>
  );
};

export default ReviewCard;
